/* eslint-disable react/display-name */
import React from 'react';

import {
    EmployeeDialog,
    EmployeeRFIDDialog,
    FuelTankDialog,
    RFIDCardDialog,
    SendRFIDCardsDialog,
    VehicleDialog,
    VehicleRFIDDialog,
} from './components';

import About from './components/ApplicationAboutDialog/ApplicationAboutDialog';
import UserProfileDialog from './components/UserProfileDialog/UserProfileDialog';
import BookmarksListDialog from '../../pages/discovery/components/BookmarksList/BookmarkListDialog';

import {
    ABOUT,
    ATTRIBUTES,
    BOOKMARKS_LIST,
    DEVICE,
    EDIT_MONITORED_OBJECT,
    EMPLOYEE,
    EMPLOYEE_RFID,
    FUEL_TANK,
    GRID_VIEW,
    LIVE_VIEW,
    LOGIN_MIGRATION,
    OBJECT_RECALCULATION,
    PLAYER_SETTINGS,
    PRODUCT_ASSIGNMENT,
    REGISTER_VEHICLE,
    REGISTER_VEHICLE_RFID,
    RFID_CARD,
    ROUTES_MANAGEMENT_TASKS_ASSIGN_CONFIRMATION,
    SEND_RFID_CARDS,
    TASK_ID_ROUTES,
    TASK_MODIFICATION,
    TICKET_HISTORY_GRID,
    USER_EDITION,
    USER_PROFILE,
} from '../../constants/dictionaries/GlobalDialogTypes';
import LoginMigrationDialog from './components/LoginMigrationDialog';
import GridViewDialog from './components/GridViewDialog';
import RouteAssingDialog from './components/RouteAssignDialog';
import AttributesDialog from './components/AttributesDialog';
import PlayerSettingsDialog from './components/PlayerSettingsDialog/PlayerSettingsDialog';
import { IPlayerSettings } from '../../state/ui/discoverySlice';
import TaskGridDialog, {
    ITaskGridDialogFilter,
} from './components/TaskGridDialog';
import EditObjectDialog from './components/EditObjectDialog';
import { IHeaderData } from './components/EditObjectDialog/types';
import TaskModificationDialog from './components/TaskModificationDialog/TaskModificationDialog';
import { ITaskModificationDialogParams } from './components/TaskModificationDialog/types';
import ObjectRecalculationDialog from './components/ObjectRecalculationDialog';
import { IDevice, IReportEntity } from '../../state/types';
import LiveViewDialog from './components/LiveViewDialog';
import ProductAssignmentDialog from './components/ProductAssignmentDialog';
import { IProduct } from '../../features/Products/types';
import { DeviceDialog } from './components/device/DeviceDialog';
import TicketHistoryGridDialog from './components/TicketHistoryGridDialog';
import { UserEditDialog } from '@/app/components/globalDialog/components/UserEditDialog/UserEditDialog';
import { IUser } from '@/app/state/app/collections/dataTypes';
import { TDeviceDialogType } from './components/device/types';

export default {
    [EMPLOYEE]: (data: any) => <EmployeeDialog employee={data.employee} />,
    [EMPLOYEE_RFID]: (data: any) => (
        <EmployeeRFIDDialog employee={data.employee} />
    ),
    [REGISTER_VEHICLE]: (data: any) => <VehicleDialog vehicle={data.vehicle} />,
    [REGISTER_VEHICLE_RFID]: (data: any) => (
        <VehicleRFIDDialog vehicle={data.vehicle} />
    ),
    [RFID_CARD]: (data: any) => <RFIDCardDialog rfidCard={data.rfidCard} />,
    [FUEL_TANK]: (data: any) => <FuelTankDialog tank={data.fuelTank} />,
    [SEND_RFID_CARDS]: (data: any) => (
        <SendRFIDCardsDialog fuelTank={data.fuelTank} />
    ),
    [ABOUT]: () => <About />,
    [USER_PROFILE]: () => <UserProfileDialog />,
    [BOOKMARKS_LIST]: () => <BookmarksListDialog />,
    [LOGIN_MIGRATION]: (data: { redirectAfterLogin?: () => void }) => (
        <LoginMigrationDialog redirectAfterLogin={data?.redirectAfterLogin} />
    ),
    [GRID_VIEW]: (data: { id?: string; sourceSet: string }) => {
        return <GridViewDialog viewId={data.id} sourceSet={data.sourceSet} />;
    },
    [ATTRIBUTES]: (data: { id?: string }) => {
        return <AttributesDialog attributeId={data.id} />;
    },
    [ROUTES_MANAGEMENT_TASKS_ASSIGN_CONFIRMATION]: (data: {
        tasks: {
            tasksList: { routeName: string; count: number }[];
            ids: number[];
        };
        target: { name: string; id: number };
        warning: boolean;
    }) => {
        return (
            <RouteAssingDialog
                tasks={data.tasks}
                target={data.target}
                warning={data.warning}
            />
        );
    },

    [PLAYER_SETTINGS]: (data: {
        handleChange: () => any;
        playerSettings: IPlayerSettings;
    }) => {
        return (
            <PlayerSettingsDialog
                playerSettings={data.playerSettings}
                handleChange={data.handleChange}
            />
        );
    },
    [LIVE_VIEW]: (data: { handleChange: () => any; monitoredId: string }) => {
        return <LiveViewDialog monitoredId={data.monitoredId} />;
    },
    [TASK_ID_ROUTES]: (data: {
        filter: ITaskGridDialogFilter;
        routeId?: number;
        setFieldValue: (field: string, value: any) => void;
    }) => {
        return (
            <TaskGridDialog
                filter={data.filter}
                routeId={data.routeId}
                setFieldValue={data.setFieldValue}
            />
        );
    },
    [EDIT_MONITORED_OBJECT]: (data: {
        headerData: IHeaderData;
        onSuccess: () => void;
    }) => {
        return (
            <EditObjectDialog
                headerData={data.headerData}
                onSuccess={data.onSuccess}
            />
        );
    },
    [TASK_MODIFICATION]: (data: ITaskModificationDialogParams) => {
        return <TaskModificationDialog dialogData={data} />;
    },
    [OBJECT_RECALCULATION]: (data: {
        data: IReportEntity;
        monitoredId: string;
        dateFormat: string;
    }) => {
        return (
            <ObjectRecalculationDialog
                data={data.data}
                monitoredId={data.monitoredId}
                dateFormat={data.dateFormat}
            />
        );
    },
    [PRODUCT_ASSIGNMENT]: (data: { selectedProduct: IProduct }) => {
        return (
            <ProductAssignmentDialog selectedProduct={data.selectedProduct} />
        );
    },
    [DEVICE]: (data: { mode: TDeviceDialogType; device: IDevice }) => {
        return <DeviceDialog mode={data.mode} selectedDevice={data.device} />;
    },
    [USER_EDITION]: (data: { selectedUser: IUser; onSave: () => void }) => {
        return <UserEditDialog user={data.selectedUser} onSave={data.onSave} />;
    },

    [TICKET_HISTORY_GRID]: (data: { ticketId: string }) => {
        return <TicketHistoryGridDialog ticketId={data.ticketId} />;
    },
};
